// Filter för puff tags
jQuery(document).ready(function ($){
    $(".cat-item").each(function () {
        $(this).on("click", function () {
          $('.cat-item').removeClass('active');
          $(this).addClass('active');
          $('.puff').removeClass('active');
          $('.puff[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
          if ($(this).data('id') == 'all-items') {
            $('.puff').addClass('active');
          }
        });
    });
});